module.exports = __webpack_public_path__ + "media/images/icons/arrow_backward-271546d29a134ccd97772a0a32692460.svg";